import { SiderProps } from '@app/types'

import { StyledSider } from './elements'

export const Sider: React.FC<SiderProps> = (props) => <StyledSider {...props} />
